import React from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@cyberint/dsc';
import { DemoPageForm } from './DemoPageForm';
import * as S from './styled';

export const DemoPage = ({ user, tenantId }) => {
  const createPhrase = (title, body) => (
    <S.Phrase>
      <Icons.CheckOutlined />
      <S.PhraseContent>
        <div>
          <strong>{title}:</strong>
        </div>
        <div className="phrase-body">{body}</div>
      </S.PhraseContent>
    </S.Phrase>
  );

  return (
    <S.DemoPageWrapper>
      <S.DescriptionColumn>
        <S.DescriptionWrapper>
          <S.Title>Get a Demo of External Risk Management (ERM)</S.Title>
          <S.Phrase>
            <span className="phrase-body title-description">
              During the session, we will demonstrate our capabilities by uncovering hidden risks and emerging cyber
              security threats targeting your brand.
            </span>
          </S.Phrase>
          {createPhrase(
            'Deep & Dark Web Visibility',
            'We provide insights on emerging threats from an ever-growing list of sources, such as Telegram, forums & marketplaces'
          )}
          {createPhrase(
            'Strategic Threat Intelligence',
            'Our strategic threat knowledgebase provides a library of intel on threat actors, malware families, and documented CVEs'
          )}
          {createPhrase(
            'Attack Surface Management',
            'Gain visibility of your true attack surface – the digital assets you are aware of, plus the shadow IT assets you are unaware of'
          )}
          {createPhrase(
            'Supply Chain Intelligence',
            'Our Supply Chain Intelligence module continuously monitors your vendors and suppliers for relevant cyber risks and incidents.'
          )}
          {createPhrase(
            'Online Brand Protection',
            'We help brands to detect and takedown malicious impersonation attacks that masquerade as their brand or its executives'
          )}
        </S.DescriptionWrapper>
      </S.DescriptionColumn>
      <S.DemoColumn>
        <DemoPageForm user={user} tenantId={tenantId} />
      </S.DemoColumn>
    </S.DemoPageWrapper>
  );
};

DemoPage.propTypes = {
  user: PropTypes.shape({}),
  tenantId: PropTypes.string
};
